import React from "react";

const SingleBlogPage = () => {
  // 🔍 Find blog by formatted title_eng
  const blog = {
    title: "Example Blog Title",
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis, iusto. Error sapiente repellendus exercitationem qui. Obcaecati nobis unde magnam vero qui perspiciatis quod beatae a exercitationem. Fugit rerum earum eos a fugiat illo nisi nemo! Similique fuga magni harum repellendus iusto.\nMolestias porro rerum ex, quidem mollitia sequi id ab dicta delectus perferendis aut et eius enim ut quod libero reiciendis optio amet officia doloribus at hic! Quod perferendis modi dolorum reprehenderit tempora.\nAliquam nesciunt in, distinctio soluta non suscipit laudantium.\nTotam facilis itaque officiis odio ipsum laborum magni veritatis incidunt quam.\nAb vero eveniet sint cumque corrupti cum! Illum repellat reiciendis architecto aut neque dolores! At ullam ex, possimus sed voluptatem omnis saepe facere quisquam dignissimos laborum consectetur quidem pariatur doloribus nam temporibus quis quam blanditiis cupiditate error veritatis illo excepturi repellat iusto tempore.\nFacilis voluptatibus sed asperiores.\nSed animi voluptates est nobis saepe aut cum amet sunt sequi.\nLorem ipsum dolor sit amet, consectetur adipisicing elit.\nCulpa pariatur praesentium est esse magnam commodi facilis, veritatis hic rerum facere, a perferendis dolorem, totam quidem.\nSoluta nostrum iste quae optio dolores nulla, possimus vel voluptatum eligendi quia eum, similique ipsam consectetur? Cupiditate sunt deleniti pariatur totam repellendus, numquam iste laborum quo nam excepturi consectetur et illo, aliquid enim molestiae officia, fugiat quaerat.\nAd laudantium quia rem repellat veniam, incidunt, reiciendis excepturi consequuntur alias necessitatibus, molestias velit quibusdam deserunt quisquam voluptate.\nPariatur cupiditate dolores adipisci tempore a quam quae facere possimus? Nostrum deserunt officiis accusamus esse, inventore quam repellat ut totam possimus eos rem facilis, quibusdam cumque sequi repellendus necessitatibus corrupti, culpa voluptas.\nDoloremque possimus doloribus quis illo repellendus maxime magnam, consequatur natus rerum ullam atque fugit pariatur sed ex, obcaecati id nesciunt sunt labore laudantium iure? Ea tempora numquam facere a quaerat praesentium quibusdam vitae distinctio animi nam sit quisquam ducimus explicabo eligendi pariatur, ab quia blanditiis aut rerum quidem.\nAt odit laudantium voluptates sapiente dicta distinctio libero dolorum est, iusto explicabo? Soluta beatae laborum quo veritatis odit.\nCorrupti quas unde hic aliquid exercitationem dolorem excepturi reprehenderit ad autem ducimus, voluptatem vel eius, nisi fugit, dicta numquam illum voluptas velit?",
    tags: [
      { id: 1, tag: "Tag1" },
      { id: 2, tag: "Tag2" },
    ],
    date: "2023-10-01",
    image: "/assets/images/workshop3.webp",
  };

  if (!blog) {
    return <p className="py-40 text-center">Blog not found</p>;
  }

  // 🧠 Reading time logic
  const wordCount = blog.content.split(/\s+/).length;
  const readingTime = Math.max(1, Math.round(wordCount / 200));

  return (
    <div className="relative mx-auto max-w-screen-lg px-4 py-12 text-center md:px-12 xl:px-16">
      {/* Title */}
      <h1 className={`mb-12 text-4xl font-bold md:text-6xl`}>{blog.title}</h1>

      {/* Tags and Meta */}
      <div className="mb-12 flex flex-wrap items-center justify-between gap-3">
        {/* Tags */}
        <div className="flex flex-wrap items-center gap-3">
          {blog.tags?.map((tag) => (
            <span
              key={tag.id}
              className="group relative cursor-pointer rounded-full bg-black/5 px-3 py-1 transition-all duration-200"
            >
              <span className="bg-primary absolute inset-0 z-0 rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <span className="relative z-10">{tag.tag}</span>
            </span>
          ))}
        </div>

        {/* Meta info */}
        <div className="flex items-center space-x-3 text-sm">
          <span>{readingTime} min read</span>
          <span>•</span>
          <span>
            {new Date(blog.date).toLocaleDateString({
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </span>
        </div>
      </div>

      {/* Banner Image */}
      <div className="mb-12 h-72 w-full overflow-hidden rounded-lg md:h-[420px]">
        <img
          src={blog.image || "/assets/images/workshop3.webp"}
          alt="Blog Banner"
          className="h-full w-full"
        />
      </div>

      {/* Content */}
      <div className={`text-start text-base leading-7`}>
        {blog.content?.split("\n").map((para, i) => (
          <p key={i} className="mb-6">
            {para}
          </p>
        ))}
      </div>
    </div>
  );
};

export default SingleBlogPage;
